import { PendingApproval } from "../model/pendingApprovalModel";

export type PendingApprovalsAction =
  | {
      type: "SET_PENDING_APPROVALS";
      payload: PendingApproval[];
    }
  | { type: "SET_OPEN_MENU"; payload: string | null }
  | { type: "OPEN_REJECT_MODAL" }
  | { type: "CLOSE_REJECT_MODAL" }
  | { type: "SET_REJECT_REASON"; payload: string }
  | {
      type: "SET_STATUS_TOAST";
      payload: {
        isVisible: boolean;
        message: string;
        type: "success" | "error" | "warning" | "info";
      };
    }
  | { type: "SET_COUNT"; payload: number };
export const setPendingApprovals = (
  payload: any[],
): PendingApprovalsAction => ({
  type: "SET_PENDING_APPROVALS",
  payload,
});
export const setOpenMenu = (payload: string | null) => ({
  type: "SET_OPEN_MENU" as const,
  payload,
});
export const setCount = (payload: number): PendingApprovalsAction => ({
  type: "SET_COUNT",
  payload,
});
export const openRejectModal = (jobId: string) => ({
  type: "OPEN_REJECT_MODAL",
  payload: jobId,
});

export const closeRejectModal = () => ({
  type: "CLOSE_REJECT_MODAL",
});
export const setSTATUSToast = (payload: {
  isVisible: boolean;
  message: string;
  type: "success" | "error" | "warning" | "info";
}): PendingApprovalsAction => ({
  type: "SET_STATUS_TOAST",
  payload,
});
export const setRejectReason = (reason: string) => ({
  type: "SET_REJECT_REASON",
  payload: reason,
});
